export default {
  data() {
    return {
      pagePers: null,
    };
  },
  computed: {
  },
  methods: {
    GetFullPers() {
      this.$store.getters.axl.post('/profiles/api/pers/list', {})
        .then(({ data }) => {
          this.pagePers = data.pagePers;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  mounted() {
    this.GetFullPers();
  },
};
